export default class StockMarket {
    static init() {
        const stockMarkets = document.querySelectorAll('.js-share-price');

        stockMarkets.forEach(stockMarket => {
           this.buildTicker(stockMarket);
        });
    }

    static buildTicker(stockMarket) {
        if (stockMarket) {
            const values = [];
            return fetch('https://tools.eurolandir.com/tools/pricefeed/?companycode=f-arami')
                .then(response => response.text())
                .then(xmlString => {
                    const parser = new DOMParser();
                    return parser.parseFromString(xmlString, 'application/xml');
                })
                .then(data => {
                    data.querySelector('Ticker').childNodes.forEach(function (elem) {
                        if (elem.tagName) {
                            values[elem.tagName] = elem.textContent;
                        }
                    });

                    stockMarket.querySelectorAll('[data-field]').forEach(elem => {
                        elem.querySelector('.value').textContent = this.sanitizeValue(
                            values[elem.dataset.field],
                            elem.dataset.digits,
                            elem.dataset.date
                        );
                    });
                });
        }
    }

    static sanitizeValue(value, digits, date) {
        if (!isNaN(value) && value.toString().indexOf('.') !== -1) {
            return parseFloat(value).toFixed(digits ? digits : 2);
        } else if (date) {
            return new Date(value).toLocaleString();
        }
        return value;
    }
}